var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5597_252929",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 14,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 3.5C11.5 5.433 9.933 7 8 7C6.067 7 4.5 5.433 4.5 3.5C4.5 1.567 6.067 0 8 0C9.933 0 11.5 1.567 11.5 3.5ZM10.5 3.5C10.5 4.88071 9.38071 6 8 6C6.61929 6 5.5 4.88071 5.5 3.5C5.5 2.11929 6.61929 1 8 1C9.38071 1 10.5 2.11929 10.5 3.5Z",
    fill: "#000001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 13.2C1 10.8804 3.8 9 8 9C12.2 9 15 10.8804 15 13.2C15 14.7464 13.7464 16 12.2 16H3.8C2.2536 16 1 14.7464 1 13.2ZM2 13.2C2 12.4872 2.4237 11.718 3.45222 11.0799C4.48176 10.4411 6.03713 10 8 10C9.96287 10 11.5182 10.4411 12.5478 11.0799C13.5763 11.718 14 12.4872 14 13.2C14 14.1941 13.1941 15 12.2 15H3.8C2.80589 15 2 14.1941 2 13.2Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5597_252929)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOutlined);
export default __webpack_public_path__ + "static/media/profile-outlined.a5c8d7f024e35562d295bc43890292c2.svg";
export { ForwardRef as ReactComponent };